import {Button} from 'reactstrap';
import {Moon, Sun} from 'lucide-react';
import {useTheme} from '../../hooks/useTheme';

const ThemeToggle = ({className}: {className?: string}) => {
    const {theme, toggle} = useTheme();
    const isDark = theme === 'dark';
    const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

    return (
        <Button
            color="link"
            className={`ft-navbar__theme-toggle ${className ?? ''}`}
            onClick={toggle}
            aria-label={label}
            title={label}
        >
            {isDark ? <Sun size={18} /> : <Moon size={18} />}
        </Button>
    );
};

export default ThemeToggle;
